module.exports = __webpack_public_path__ + "img/E-WEB-Goal-10.25b8202f.png";